import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-share-location',
  templateUrl: './share-location.component.html',
  styleUrls: ['./share-location.component.css']
})
export class ShareLocationComponent implements OnInit {
  lat: number = 51.678418;
  lng: number = 7.809007;
  
  constructor() { }

  ngOnInit(): void {
  }

}
